export function isJSON(str) {
    // 简单的正则表达式检查，确保字符串大致符合JSON结构
    if (/^[\],:{}\s]*$/.test(str.replace(/\\["\\\/bfnrtu]/g, '@').replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
        try {
            const result = JSON.parse(str);
            const valid = (result && typeof result === 'object' && !Array.isArray(result));
            return valid; // 如果是对象但不是数组，则为有效JSON
        } catch (e) { }
    }
    return false; // 不是有效的JSON格式
}

export function getYMDHMS(timestamp) {
    let time = new Date(timestamp);
    let year = time.getFullYear();
    let month = time.getMonth() + 1;
    let date = time.getDate();
    let hours = time.getHours();
    let minute = time.getMinutes();
    let second = time.getSeconds();
    var month_str = `${month}`;
    if (month < 10) {
      month_str = "0" + `${month}`;
    }
    var data_str = `${date}`;
    if (date < 10) {
      data_str = "0" + `${date}`;
    }
    var hours_str = `${hours}`;
    if (hours < 10) {
      hours_str = "0" + `${hours}`;
    }
    var minute_str = `${minute}`;
    if (minute < 10) {
      minute_str = "0" + `${minute}`;
    }
    var second_str = `${second}`;
    if (second < 10) {
      second_str = "0" + `${second}`;
    }
    return (
      year +
      "-" +
      month_str +
      "-" +
      data_str +
      " " +
      hours_str +
      ":" +
      minute_str +
      ":" +
      second_str
    );
    // return `${year}`
  }

/**
 * 
 * @param {*} file 
 * @returns {base64:'',origionsize:{width:0,height:0}}
 */
export async function imagefile_to_thumbnail_base64(file){
		
		// console.log('image_thumbnail_base64',file)
		let file_size = file.size //单位bit。注意：融云缩略图需小于120kb.所以我们以100kb为最大单位比。
		let max_rate = file_size/100000 
		return new Promise((resolve,reject)=>{

      const reader = new FileReader();
      reader.onload = function(res) {
          const img = new Image();
          
          img.onload = () => {
              console.log('Image:', img); // 图片宽度
              let canvasWidth = img.width; // 图片原始宽度
						  let canvasHeight = img.height; // 图片原始高度
						  // console.log('宽度-',canvasWidth,'高度-',canvasHeight);
						  img.src = img.path;
						  let canvas = document.createElement('canvas');
						  let ctx = canvas.getContext('2d');
						  // 这里根据要求限制图片宽高
						  var w = img.width
						  var h = img.height
						  var max  = Math.max(canvasWidth,canvasHeight)
						  let max_width_height = 240
						    // console.log('调整前尺寸为：',canvasWidth,canvasHeight)
						  if(max_width_height > max/max_rate){
							  max_width_height =  max/max_rate
							  // console.log('调整最大尺寸为：',max_width_height)
						  }
						  
						  let size = scaleDown(canvasWidth,canvasHeight,max_width_height,max_width_height)
						  
						 
						  canvas.width = size.width 
						  canvas.height = size.height
						   // console.log('新宽度-',canvas.width,'新高度-',canvas.height);
						  ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
						  //toBlob()方法创造Blob对象，用以展示canvas上的图片
						  // canvas.toBlob(function(fileSrc) {
						  //   let imgSrc = window.URL.createObjectURL(fileSrc);
						  //   console.log('压缩后的blob路径', imgSrc);
						  // });
						  //图片data.
						  let result = canvas.toDataURL('image/png').replace(/^data:image\/\w+;base64,/, "")
						  // console.log('image_thumbnail_base64-result',result)
						  //注意如果result.length>108000bit,则注意,缩略图不能超过120kb.不然融云消息发送不出去。
              //完全的base64编码
						  resolve({
                base64:`data:image/png;base64,${result}`,
                origionsize:{
                  width:canvasWidth,
                  height:canvasHeight
                }
              })
          };
          img.src = res.target.result; // 设置img的src为FileReader读取的结果
          
      };
      reader.readAsDataURL(file);
		})
	}

function scaleDown(width, height, maxWidth, maxHeight) {
    if (width < maxWidth && height < maxHeight) {
        return {width, height}
    }

    const widthRatio = maxWidth / width;
    const heightRatio = maxHeight / height;

    // 计算比例最小的缩放倍数
    const scale = Math.min(widthRatio, heightRatio);

    // 缩放后的宽度和高度
    const scaledWidth = width * scale;
    const scaledHeight = height * scale;

    return {width: Math.ceil(scaledWidth), height: Math.ceil(scaledHeight)};
}

/**
 * digits:保留小数点后位数
*/
export function num_to_KM(num,digits=1){
  if (num >= 1000 && num < 1000000) {
    return (num / 1000).toFixed(digits) + 'K';
  } else if (num >= 1000000) {
    return (num / 1000000).toFixed(digits) + 'M';
  }
  return num.toString();
}

export function str_to_array(str,sep=','){
	return str.split(sep)
}

export function lang_auto_trans(lang_content,defulate_content){
	
	if(!lang_content.length || !isJSON(lang_content)){
		return defulate_content
	}
	const lan_content_objct = JSON.parse(lang_content)
  //1默认:中文
	return lan_content_objct[1]
	
}

export function findNodeById(tree, id) {
  for (let node of tree) {
      if (node.id === id) {
          return [node];
      }
      if (node.children) {
          let result = findNodeById(node.children, id);
          if (result) {
              return [node, ...result];
          }
      }
  }
  return null;
}

 /**
 * 生成8位随机数字字符串，第一位不会是0
 * @returns {string} 8位数字
 */
export function getRandom8Num() {
  // 第一位：1~9
  let first = Math.floor(Math.random() * 9) + 1;
  let rest = '';
  // 后7位：0~9
  for (let i = 0; i < 7; i++) {
    rest += Math.floor(Math.random() * 10);
  }
  return first + rest;
}